import { createApiClient, createQueryClient } from '@esnafai/shared/api';
import { redirectToLogin } from '@esnafai/shared/auth';
import type { AnyRouter } from '@tanstack/react-router';
import { watchServerClock } from './clock-skew';
import { config } from './config';

// The app's query cache and API client (UI architecture §4). A 401 sends the app to /login?returnTo= through the
// router, which router.ts binds here once it exists (the router needs the client first).
export const queryClient = createQueryClient();

let boundRouter: AnyRouter | undefined;

export function bindRouter(router: AnyRouter): void {
  boundRouter = router;
}

export const api = createApiClient({
  baseUrl: config.apiBaseUrl,
  panel: 'merchant',
  onUnauthenticated: () => {
    if (boundRouter) redirectToLogin(boundRouter, queryClient, 'merchant');
  },
});

// The start-up GET /me already carries the server's Date (merchant screens §4.1 Clock).
watchServerClock(api);

// The app session's one stream (UI architecture §5), on the API's origin.
export const streamUrl = `${config.apiBaseUrl}/api/stream`;
